import {ThemeColorPath, ThemeIconKey} from 'platform/foundation';

// FE-owned icon per operation group (keyed by the group/label key from
// PAY_PER_USE_OPERATION_LABEL). Groups not listed fall back to
// DEFAULT_OPERATION_ICON, keeping the UI data-driven as new actions appear.
export const PAY_PER_USE_OPERATION_ICON: Record<string, ThemeIconKey> = {
  'page.payPerUseMetrics.operation.cebiaAutotracer': 'action/history',
  'page.payPerUseMetrics.operation.vinDecoding': 'action/search',
  'page.payPerUseMetrics.operation.priceReport': 'action/receipt',
  'page.payPerUseMetrics.operation.invoiceExtraction': 'action/find_in_page',
  'page.payPerUseMetrics.operation.backgroundRemoval': 'image/photo',
  'page.payPerUseMetrics.operation.aiDescription': 'action/description',
  'page.payPerUseMetrics.operation.photoCheckerReport': 'image/photo_camera',
};

export const DEFAULT_OPERATION_ICON: ThemeIconKey = 'action/dashboard';

export const OPERATION_ICON_COLOR: ThemeColorPath = 'palettes.blue.70.100';
export const OPERATION_ICON_BACKGROUND: ThemeColorPath = 'palettes.blue.20.100';
